var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinBagSolidLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.527,
    height: 25,
    viewBox: "0 0 25.527 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin-bag-solid",
    transform: "translate(-3.047 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M20.662,21.452H27c-.532-7.024-3.556-11.387-7.435-13.968l1.766-3.855A.806.806,0,0,0,20.6,2.5H9.541a.806.806,0,0,0-.734,1.129l.968,2.1h8.161l-.726,1.613H15.719a20.08,20.08,0,0,1,1,3.782,19.751,19.751,0,0,1,.258,2.419l-1.274.9a18.177,18.177,0,0,0-.258-3.113A17.532,17.532,0,0,0,14.3,7.339h-.806a22.758,22.758,0,0,0-2,2.984,19.282,19.282,0,0,0-1.2,2.79l-1.1-.734a18.371,18.371,0,0,1,1.185-2.694A24.846,24.846,0,0,1,11.92,7.339H10.509l.065.137C6.3,10.323,3.049,15.323,3.049,23.669a1.331,1.331,0,0,0,1.258,1.411h6.452a2.153,2.153,0,0,1,1.29-3.629,2.153,2.153,0,0,1-.3-1.081,2.177,2.177,0,0,1,2.177-2.177h4.839a2.177,2.177,0,0,1,2.177,2.177A2.121,2.121,0,0,1,20.662,21.452Z",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M20.052,28.306a.806.806,0,0,0-.806-.806H14.406a.806.806,0,0,0,0,1.613h4.839A.806.806,0,0,0,20.052,28.306Z",
    transform: "translate(-2.043 -4.839)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M21.185,23.5H16.346a.806.806,0,1,0,0,1.613h4.839a.806.806,0,1,0,0-1.613Z",
    transform: "translate(-2.418 -4.065)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M20.645,31.5H15.806a.806.806,0,1,0,0,1.613h4.839a.806.806,0,1,0,0-1.613Z",
    transform: "translate(-2.314 -5.613)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M31.152,31.5H25.506a.806.806,0,1,0,0,1.613h5.645a.806.806,0,1,0,0-1.613Z",
    transform: "translate(-4.191 -5.613)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M32.152,27.5H26.506a.806.806,0,1,0,0,1.613h5.645a.806.806,0,1,0,0-1.613Z",
    transform: "translate(-4.384 -4.839)",
    fill: "#FFE3D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinBagSolidLight);
export default __webpack_public_path__ + "static/media/coin-bag-solid--light.d93442350ae7884d932ce7b3b92de6ff.svg";
export { ForwardRef as ReactComponent };